<div class="content w-full h-full flex items-center justify-center bg-(--comp-app-bg)">
  @if (userMenus) {
    <div class="max-w-4xl px-16 py-6 box-home mb-5 2xl:mb-20">
      <div class="text-primary font-bold">
        <img class="w-87.5 my-6" src="assets/icons/logo-dynamic-einteligent.svg" alt="" />
      </div>
      <div class="flex gap-10">
        @for (card of userMenus; track card) {
          <div class="flex justify-center items-center">
            <div
              (click)="menuRuter = card; card.url ? goToUrl([card.url], {}) : null"
              class="button-menu"
            >
              <div class="bg-white rounded-full p-1 h-20 w-20 flex items-center justify-center">
                <mat-icon class="menu-icon">{{ card.icon }}</mat-icon>
              </div>
              {{ card.description | translate }}
            </div>
          </div>
        }
      </div>

      <div class="h-36 min-w-[80%]">
        @if (menuRuter && menuRuter!.menu!.length) {
          <div
            class="text-primaryCarvest font-bold text-base text-(--color-text-title) mb-4 w-full justify-center items-center flex"
          >
            {{ menuRuter.description | translate }}
          </div>
          <div class="p-4 gap-2 flex flex-wrap justify-center">
            @for (menu of menuRuter.menu; track menu) {
              <div
                (click)="navigateMenu(menu, $index, menuRuter.isTab)"
                class="min-w-40 cursor-pointer bg-white p-4 rounded-3xl shadow-xl inset-shadow-sm text-(--color-text-gray) border-2 border-transparent hover:border-2 font-medium hover:border-(--color-text-primary) hover:text-(--color-text-primary) transition-colors"
              >
                {{ menu.description | translate }}
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>

<!--<app-new-quotation></app-new-quotation> -->
